import React, { useState } from "react";
import { Box, Grid, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Paper } from '@mui/material';
import { getUserObject } from "../../../actions/profile/UserActions";
import { getAllSites, getAllSubmissions } from "../../../selectors/AdminSelectors";
import { observer } from "mobx-react-lite";
import { withRouter } from "react-router-dom";
import { Add, AssessmentOutlined, AssignmentOutlined, EmailOutlined, PersonOutline, StoreOutlined } from "@mui/icons-material";
import { ContainedButton, TooltipIconButton } from "../../common/StyledButtons";
import Colors from "../../../constants/Colors";
import { CARD_HEADER_STYLE } from "../../../constants/Styles";
import { formatDateTimeToFancyString } from "../../../utilities/DateUtilities";
import StyledStatusIcon from "../../common/StyledStatusIcon";
import { SUBMISSION_STATUS, SUBMISSION_TYPES_HUMAN_MAP } from "../../../constants/Statuses";
import ViewRequestModal from "../modals/ViewRequestModal";
import AdminAddRequestModal from "../modals/AdminAddRequestModal";
import StyledPage from "../../common/StyledPage";

const AdminComponent = ({ history }) => {

    const [requestInView, setRequestInView] = useState();
    const [openAddRequest, setOpenAddRequest] = useState();

    const submissions = getAllSubmissions();

    const handleViewRequestOnClose = () => {
        setRequestInView();
    }

    const handleAddRequestOnClose = () => {
        setOpenAddRequest(false)
    }

    const renderGreeting = () => {
        const today = new Date()
        if (today.getHours() < 6 ) return 'Evening'
        else if (today.getHours() >= 6 && today.getHours() < 12) return 'Morning'
        else if (today.getHours() >= 12 && today.getHours() < 18) return 'Afternoon'
        else if (today.getHours() >= 18) return 'Evening'
    }

    const getFirstName = () => (
        getUserObject() && `${getUserObject().user_personal.first_name}`
    )

    const createSubmissionTitle = (submission) => {
        const type = SUBMISSION_TYPES_HUMAN_MAP[submission.submission_type] || submission.submission_type
        if (submission.submission_identifiers.site) {
            return `${type} ${submission.submission_id.substring(submission.submission_id.length - 6).toUpperCase()}: ${submission.submission_identifiers.site.site_name}`
        } else if (submission.submission_identifiers.user) {
            return `${type} ${submission.submission_id.substring(submission.submission_id.length - 6).toUpperCase()}: ${submission.submission_identifiers.user.first_name} ${submission.submission_identifiers.user.last_name}`
        }
        return type;
    }

    const renderSubmissions = () => {
        return (
            <Grid item xs={12}>
                <List style={{ flex: 1 }}>
                    {submissions && sortSubmissions(submissions).map((submission) => (
                        <ListItem
                            dense
                            sx={{ backgroundColor: '#fff', marginBottom: '5px' }}
                            key={submission.submission_id}
                        >
                            <ListItemAvatar>
                                <StyledStatusIcon status={submission.submission_status} />
                            </ListItemAvatar>
                            <ListItemText primary={createSubmissionTitle(submission)} secondary={formatDateTimeToFancyString(submission.submission_received_epoch)} />
                            <ListItemSecondaryAction>
                                <TooltipIconButton
                                    text={'View Details'}
                                    icon= {<AssignmentOutlined sx={{ color: Colors.primaryColor }}
                                    onClick={() => setRequestInView(submission)}
                                /> } />
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
                    {(!submissions || submissions.length === 0) &&
                        <p>No active requests.</p>
                    }
                </List>
            </Grid>
        )
    }

    const sortSubmissions = (subs) => {
        subs.sort((a, b) => {
            const awaitingStatus = SUBMISSION_STATUS.AWAITING_DETAILS;
        
            const aIsAwaiting = a.submission_status === awaitingStatus;
            const bIsAwaiting = b.submission_status === awaitingStatus;
        
            // If one is awaiting and the other is not, push the awaiting one to the bottom
            if (aIsAwaiting && !bIsAwaiting) return 1;
            if (!aIsAwaiting && bIsAwaiting) return -1;
        
            // Otherwise, sort by submission_received_epoch ascending
            return a.submission_received_epoch - b.submission_received_epoch;
        });
        return subs;
    }
      
    return (
        <StyledPage>
            <h3 style={{ margin: 0, paddingTop: '10px' }}>Admin Panel</h3>
            <h5 style={{ margin: 0, paddingBottom: '10px' }}>Good {renderGreeting()}, {getFirstName()}!</h5>
            <Grid container spacing={2} sx={{ marginTop: '24px' }}>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                        <h6>Active Requests</h6>
                        <TooltipIconButton
                            text={"Add New Request"}
                            icon= {<Add />}
                            onClick={() => setOpenAddRequest(true)}
                        />
                    </Box>
                    
                </Grid>
                {renderSubmissions()}
            </Grid>
            <ViewRequestModal
                open={!!requestInView}
                onClose={handleViewRequestOnClose}
                request={requestInView}
            />
            <AdminAddRequestModal
                open={openAddRequest}
                onClose={handleAddRequestOnClose}
            />
        </StyledPage>
       
    )
}

export default withRouter(observer(AdminComponent));

